var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "warning" },
        [
          _vm.maintenance
            ? _c(
                "el-alert",
                {
                  attrs: { type: "error", center: "", closable: "" },
                  on: {
                    close: function($event) {
                      _vm.maintenance = false
                    }
                  }
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("maintenance")) + "\n\t\t")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { maintenance: _vm.maintenance }, attrs: { id: "app" } },
        [
          _c("router-view"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                bottom: "2px",
                left: "2px",
                "z-index": "999999",
                "font-size": "9px",
                color: "#ddd"
              }
            },
            [
              _vm._v(
                "version: " +
                  _vm._s(_vm.releaseVersion) +
                  " (" +
                  _vm._s(_vm.commitHash) +
                  " )"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [_c("pdf-preview-dialog")], 1),
      _vm._v(" "),
      _c("action-detail-dialog", {
        staticStyle: { "z-index": "5000" },
        attrs: {
          visible: _vm.actionDetailDialogVisibleStore,
          "component-type": _vm.componentTypeStore
        }
      }),
      _vm._v(" "),
      _c("action-phone-detail-overlay", {
        staticStyle: { "z-index": "5000" },
        attrs: {
          action: _vm.actionPhoneDetailOverlayAction,
          visible: _vm.actionPhoneDetailOverlayVisible
        }
      }),
      _vm._v(" "),
      _c("create-phone-action-overlay"),
      _vm._v(" "),
      _c("email-detail-dialog", {
        staticStyle: { "z-index": "5000" },
        attrs: {
          visible: _vm.emailDetailDialogVisibleStore,
          "message-ref": _vm.emailDetailDialogMessage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }